import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { QrCode, ScanLine, X } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { useQrScanner } from "./useQrScanner";

// مسح رمز الفرع/الطابق بالكاميرا الحيّة فقط — لا إدخال يدوي ولا رفع صورة، منعاً للتحايل.
export const QrScanStep = ({ onCode, onClose }) => {
  const { t } = useTranslation();
  const found = useCallback((value) => onCode(value), [onCode]);
  const { videoRef, error } = useQrScanner(true, found);

  return (
    <div className="flex flex-1 flex-col overflow-y-auto" data-testid="qr-scan-step">
      <div className="sticky top-0 z-10 -mx-4 flex items-center justify-between gap-2 bg-background px-4 pb-3 pt-1">
        <p className="flex items-center gap-2 text-sm font-black text-primary">
          <QrCode className="h-5 w-5 shrink-0" /> {t("qr.scanTitle")}
        </p>
        <NeuButton type="button" data-testid="qr-scan-cancel" onClick={onClose}
          className="flex items-center gap-1.5 px-4 py-2 text-sm font-bold">
          <X className="h-4 w-4" /> {t("app.close")}
        </NeuButton>
      </div>

      <div className="relative mt-1 h-[58vh] w-full overflow-hidden rounded-[28px] bg-black shadow-neu-in">
        <video ref={videoRef} playsInline muted className="h-full w-full object-cover" data-testid="qr-scan-video" />
        <div className="pointer-events-none absolute inset-10 rounded-3xl border-2 border-white/70" />
        <ScanLine className="pointer-events-none absolute inset-x-10 top-1/2 h-10 w-auto animate-pulse text-white/80" />
      </div>

      {error ? (
        <p className="mt-3 text-center text-xs font-bold text-destructive" data-testid="qr-scan-error">
          {t("qr.cameraError")}
        </p>
      ) : (
        <p className="mt-3 text-center text-xs text-muted-foreground">{t("qr.scanHint")}</p>
      )}

      <NeuButton type="button" data-testid="qr-scan-cancel-bottom" onClick={onClose} className="mt-4 w-full py-3">
        {t("app.cancel")}
      </NeuButton>
    </div>
  );
};
